import styled from '@emotion/styled';
import React from 'react';
import { Image } from 'react-bootstrap';
//import { Typography } from './Typography';

/*
interface SidebarHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
    rtl: boolean;
}
*/    

const StyledSidebarHeader = styled.div`
    height: 64px;
    min-height: 64px;
    display: flex;
    align-items: center;
    padding: 0 20px;

    > div {
        width: 100%;
        overflow: hidden;
    }
`;


export const SidebarHeader = ({ children, ...rest }) => {
    return (
        <StyledSidebarHeader {...rest}>
        <div style={{ display: 'flex', alignItems: 'center'}}>  
            <Image src='/logo512.png' style={{width:'80px'}}/>
            <div style={{fontWeight:'700'}}>
                Jueces Liga Cantabria
            </div>      
        </div>
        </StyledSidebarHeader>
    );
};